import { CompassCanvas, getDirectionName } from "@/global/utils/display-utils"
import { useEffect, useState } from "react"
import "./index.less"
import { queryInfluxCurrentData, queryInfluxDataList } from "@/api/influx/influx"
import { TimeValue } from "@/global/interface/time-value"
import { message } from "antd"
import { findSensorParameterDtoBySensorIds, getSensorByPrimitiveUuid } from "@/api/device/sensor"
import { Sensor, SensorParameter } from "@/global/interface/device/sensor"
import TnMessage from "@/global/components/message"

interface IProps {
    sensorId: number
}

export default function WindFirstPanel(props: IProps) {

    const [angle, setAngle] = useState<number>(0)

    const [windSpeed, setWindSpeed] = useState<number>(0)

    const [wsParam, setWsParam] = useState<SensorParameter>();
    const [wdParam, setWdParam] = useState<SensorParameter>();

    useEffect(() => {
        generateData()
    }, [props.sensorId])

    useEffect(() => {
        setAngle(0)
        setWindSpeed(0)
        flushWdData()
        flushWsData()
        const interval = setInterval(() => {
            flushWdData()
            flushWsData()
        }, 2000)

        return (() => {
            clearInterval(interval)
        })
    }, [wsParam, wdParam])

    const generateData = () => {
        // 获取真实传感器id
        if (!props.sensorId) {
            return
        }
        findSensorParameterDtoBySensorIds([props.sensorId]).then(res => {
            let sensorParams: SensorParameter[] = res.data || []
            // 获取symblo类型为ws的参数
            let wsParams: SensorParameter = sensorParams.find(item => item.symbol == "ws")
            setWsParam(wsParams);
            // 获取symblo类型为wd的参数
            let wdParams: SensorParameter = sensorParams.find(item => item.symbol == "wd")
            setWdParam(wdParams);
        }).catch(e => {
            TnMessage.error("获取数据失败！")
        })
    }

    const flushWdData = () => {
        if (wdParam == null) return;
        queryInfluxCurrentData(wdParam.id, "wd", "sensor").then(res=> {
            let timeValue: TimeValue = res.data;
            if (timeValue) {
                setAngle(timeValue.value)
            }
        })
    }

    const flushWsData = () => {
        if (wsParam == null) return;
        queryInfluxCurrentData(wsParam.id, "ws", "sensor").then(res => {
            let timeValue: TimeValue = res.data;
            if (timeValue) {
                setWindSpeed(timeValue.value)
            }
        })
    }

    return (
        <div className="wind-first">
            <div className="left">
                <div className="speed-value-wrapper">
                        <div className="speed-value">
                            {windSpeed?.toFixed(1)}
                        </div>
                        <div className="speed-suffix">
                            <div className="speed-unit">
                                {"米 / 秒"}
                            </div>
                            <div className="speed-name">
                                {"风速"}
                            </div>
                        </div>
                    </div>
                    <div className="hr" />
                    <div className="speed-value-wrapper">
                        <div className="speed-value">
                            {((angle * 180 / Math.PI).toFixed(0) || "0") + "°"}
                        </div>
                        <div className="speed-suffix">
                            <div className="speed-unit">
                                {"度"}
                            </div>
                            <div className="speed-name">
                                {"风向"}
                            </div>
                        </div>
                    </div>
            </div>
            <div className="right">
                <CompassCanvas angle={angle} />
            </div>
        </div>
    )
}